import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { ItemGroupingsActions } from './item-groupings.actions';
import { ItemGroupingsSelectors } from './item-groupings.selectors';
import {AsyncActionQueries, AsyncActionSelectors} from '@emm/core/util/async-action-state';
import {AsyncActionStoreService} from '@emm/core/store/async-action-store.service';
import {State as CoreState} from '@emm/core/store/core.reducer';
import {Item} from '@emm/core/models/item.model';
import {getActionQueries} from '@emm/core/util/ngrx.util';


export interface ItemGroupingsQueries extends AsyncActionQueries {} // todo

@Injectable({ providedIn: 'root' })
export class ItemGroupingsStoreService extends AsyncActionStoreService<AsyncActionSelectors> {

    constructor(store: Store<CoreState>, private actions$: Actions) {
        super(store, ItemGroupingsSelectors);
    }

    dispatch = {
        selectItemGrouping: (tag: string) =>
            this.store.dispatch(ItemGroupingsActions.select({ tag })),
        loadAllChildItems: (id: string) =>
            this.store.dispatch(ItemGroupingsActions.loadAllChildItems({ id })),
        toggleItemGroupingDisabled: (tag: string, enabled: boolean) =>
            this.store.dispatch(ItemGroupingsActions.toggleDisabled({ tag, enabled })),
        addItemGroupChildItem: (parentTag: string, children: Item[], isGlobalAdd: boolean) =>
            this.store.dispatch(ItemGroupingsActions.addChildItem({ parentTag, children, isGlobalAdd })),
        deleteItemGroup: (tag: string) =>
            this.store.dispatch(ItemGroupingsActions.deleteItemGroup({ tag })),
        removeItemGroupChildItem: (parentTag: string, childTag: string) =>
            this.store.dispatch(ItemGroupingsActions.removeChildItem({ parentTag, childTag }))
    };

    queries: ItemGroupingsQueries = {
        ...this.asyncActionQueries,
        ...getActionQueries({
            actionCreators: ItemGroupingsActions,
            actions$: this.actions$
        })
    };

}
